export default {

    domainTitle: {
        domain1: 'Domain 1 - About You',
        domain2: 'Domain 2 - Physical Activity',
        domain3: 'Domain 3 - Eating',
        domain4: 'Domain 4 - Monitoring Blood Glucose',
        domain5: 'Domain 5 - Medication Taking',
        domain6: 'Domain 6 - Living with Diabetes',
        total: 'All Domains',
    },

    userType: {
        admin: 1,
        organisation: 2,
        clinic: 3,
        data: 4
    },

    userTypeText: {
        1: 'Admin User',
        2: 'Organisation User',
        3: 'Clinic User',
        4: 'Data User'
    },

    userTypeTextShort: {
        1: 'Admin',
        2: 'Organisation',
        3: 'Clinic',
        4: 'Data'
    }

}